// Maximum number of CSV downloads
export const MAX_NUMBER_DOWNLOADS = 5000
